import script from "./TravellerModifyMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravellerModifyMessage.vue?vue&type=script&lang=ts&setup=true"

import "./TravellerModifyMessage.vue?vue&type=style&index=0&id=5eca5006&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eca5006"]])

export default __exports__